import { useCallback } from 'react';

import { formatName } from '@libs/formatNames';

import { MemberDto, ParticipantDto, RcfAttributes } from '@features/shared/api/typings';

export function useRcfAttributesControlProps(
  participant: ParticipantDto | MemberDto,
  setRcfModalOpen: (userId: string | null) => void,
) {
  const rcfAttributes: RcfAttributes = {
    rcfIdApproved: participant.rcfIdApproved,
    userId: participant.userId,
    rcfId: participant.rcfId,
    gender: participant.gender,
    birthdayTimestampMs: participant.birthdayTimestampMs,
  };
  const handleRcfModalHide = useCallback(() => {
    setRcfModalOpen(null);
  }, [setRcfModalOpen]);
  const handleRcfModalOpen = useCallback(() => {
    setRcfModalOpen(participant.userId);
  }, [setRcfModalOpen, participant.userId]);

  return {
    userName: formatName(participant),
    value: rcfAttributes,
    openModal: handleRcfModalOpen,
    hideModal: handleRcfModalHide,
  };
}
